import type {
  LC_HolidayItemOut,
  HolidayItem,
  LC_HolidayByRegionItemOut,
  HolidayByRegionItem,
} from '../types/holiday.types';


export function mapHolidayItem(raw: LC_HolidayItemOut): HolidayItem {
  return {
    id: raw.id,
    reason: raw.reason ?? '',
    holidayTypeId: raw.holidayTypeId,
    type: raw.type ?? '',
    date: raw.date,
    nonWaivable: raw.nonWaivable,
  };
}

export function mapHolidayByRegionItem(raw: LC_HolidayByRegionItemOut): HolidayByRegionItem {
  return {
    id: raw.id,
    reason: raw.reason ?? '',
    holidayTypeId: raw.holidayTypeId,
    type: raw.type ?? '',
    regionId: raw.regionId,
    region: raw.region ?? '',
    date: raw.date,
  };
}
